<div *ngIf="card != null">
  <!-- WHEN LOADED -->
  <div id="print">
    <!-- HEADERS BOX -->
    <div id="header-box">
      <div id="header-box-logo">
        <img
          id="logo"
          src="assets/logos/logo_header_dark.png"
          alt="Val d‘Oise logo"
        />
      </div>
      <div id="header-box-categ">
        <p id="categ-box">
          <span id="categ">{{ getCategory() }} .</span>
          <span id="subcateg">{{ getSubCategory() }}</span>
        </p>
      </div>
    </div>

    <!-- MAIN BOX - (PAGE 1) -->
    <div class="page">
      <!-- TITLE -->
      <p id="title-name">{{ card.title }}</p>
      <p id="title-place">{{ card.city.name }}</p>

      <!-- IMAGES GRID -->
      <div id="images-flex">
        <div id="images-left" *ngIf="doesImageExists(0)">
          <img class="image-box" src="{{ getImageUrl(0) }}" alt="Image : 1" />
        </div>
        <div id="images-right">
          <div id="image-2" *ngIf="doesImageExists(1)">
            <img class="image-box" src="{{ getImageUrl(1) }}" alt="Image : 2" />
          </div>
          <div id="image-3" *ngIf="doesImageExists(2)">
            <img class="image-box" src="{{ getImageUrl(2) }}" alt="Image : 3" />
          </div>
          <div id="image-4" *ngIf="doesImageExists(3)">
            <img class="image-box" src="{{ getImageUrl(3) }}" alt="Image : 4" />
          </div>
          <div id="image-5" *ngIf="doesImageExists(4)">
            <img class="image-box" src="{{ getImageUrl(4) }}" alt="Image : 5" />
          </div>
        </div>
      </div>

      <!-- SUB-TEXT -->
      <p id="subtext">Proposé par : {{ getCollectivities() }}</p>

      <!-- TAG LIST -->
      <div class="tag-list">
        <a *ngIf="card.mainTag != undefined" class="tag-fill">
          {{ card.mainTag.name }}
        </a>
        <a *ngFor="let tag of card.tags" class="tag-outlined">
          {{ tag.name }}
        </a>
        <div *ngIf="card.category == 1">
          <a class="tag-fill" *ngIf="circuitTypes[0]">
            <mat-icon
              style="vertical-align: middle"
              svgIcon="icon_circuit_1"
            ></mat-icon>
            À pied
          </a>
          <a class="tag-fill" *ngIf="circuitTypes[1]">
            <mat-icon
              style="vertical-align: middle"
              svgIcon="icon_circuit_2"
            ></mat-icon>
            À vélo - VTT
          </a>
          <a class="tag-fill" *ngIf="circuitTypes[2]">
            <mat-icon
              style="vertical-align: middle"
              svgIcon="icon_circuit_4"
            ></mat-icon>
            À vélo - VTC
          </a>
          <a class="tag-fill" *ngIf="circuitTypes[3]">
            <mat-icon
              style="vertical-align: middle"
              svgIcon="icon_circuit_8"
            ></mat-icon>
            À vélo - sur route
          </a>
          <a class="tag-fill" *ngIf="circuitTypes[4]">
            <mat-icon
              style="vertical-align: middle"
              svgIcon="icon_circuit_16"
            ></mat-icon>
            À cheval
          </a>
          <a class="tag-fill" *ngIf="circuitTypes[5]">
            <mat-icon
              style="vertical-align: middle"
              svgIcon="icon_circuit_32"
            ></mat-icon>
            Trail
          </a>

          <a *ngIf="card.isLoop" class="tag-outlined">
            <img
              *ngIf="card.isLoop"
              style="vertical-align: middle"
              class="img-loop-forced"
              src="assets/icons/icon_loop.png"
              aria-hidden="true"
            />
            <img
              *ngIf="!card.isLoop"
              style="vertical-align: middle"
              class="img-loop-forced"
              src="assets/icons/icon_lineaire.png"
              aria-hidden="true"
            />
            {{ card.isLoop ? 'Boucle' : 'Itinéraire' }}
          </a>
          <a class="tag-outlined">
            <mat-icon style="vertical-align: middle">tour</mat-icon>
            {{ card?.distance }} Km
          </a>
          <a class="tag-outlined">
            <mat-icon style="vertical-align: middle">trending_down</mat-icon>
            {{ card?.negativeDenivele.toFixed(0) }} m
          </a>
          <a class="tag-outlined">
            <mat-icon style="vertical-align: middle">schedule</mat-icon>
            {{ card?.duration }} H
          </a>
          <a
            class="tag-outlined"
            *ngIf="card.category === 1 && card.difficulty"
          >
            <mat-icon
              *ngIf="card.difficulty.id == 1"
              style="vertical-align: middle"
              svgIcon="circuit_difficulty_1-red"
            ></mat-icon>

            <mat-icon
              *ngIf="card.difficulty.id == 2"
              style="vertical-align: middle"
              svgIcon="circuit_difficulty_2-red"
            ></mat-icon>
            <mat-icon
              *ngIf="card.difficulty.id == 3"
              style="vertical-align: middle"
              svgIcon="circuit_difficulty_3-red"
            ></mat-icon>
            <mat-icon
              *ngIf="card.difficulty.id == 4"
              style="vertical-align: middle"
              svgIcon="circuit_difficulty_4-red"
            ></mat-icon>
            {{ card.difficulty.name }}
          </a>
        </div>
      </div>

      <!-- DESCRIPTION -->
      <p id="description-label">Description</p>
      <div id="description-content" [innerHTML]="card?.description"></div>

      <div *ngIf="card.category == 1">
        <p id="description-circuit-label">À observer en chemin :</p>
        <div
          id="description-circuit-content"
          [innerHTML]="card?.aObserverEnChemin"
        ></div>
      </div>
    </div>

    <!-- AUTO PAGE BREAK -->
    <!-- ? CIRCUIT ? -->
    <div *ngIf="card.category == 1">
      <div class="page">
        <p id="cheminement-label">Itinéraire</p>
        <div
          id="cheminement-content"
          [innerHTML]="card?.descriptionCheminement"
        ></div>
        <p id="commune-label">Communes traversées</p>
        <div *ngFor="let city of card?.crossedCities; index as i">
          <p id="commune-content">{{ city.name }} - {{ city.zipCode }}</p>
        </div>
      </div>
    </div>
    <!-- END PAGE BREAK -->

    <!-- AUTO PAGE BREAK -->
    <div>
      <!-- MAIN BOX - (PAGE 2 OR 3) -->
      <div class="page-break"></div>

      <!-- HEADERS BOX -->
      <div id="header-box">
        <div id="header-box-logo">
          <img
            id="logo"
            src="assets/logos/logo_header_dark_hight_res.png"
            alt="Val d‘Oise logo"
          />
        </div>
        <div id="header-box-categ">
          <p id="categ-box">
            <span id="categ">{{ getCategory() }} .</span>
            <span id="subcateg">{{ getSubCategory() }}</span>
          </p>
        </div>
      </div>

      <div class="page">
        <!-- THE BOX -->
        <div id="map-box">
          <!-- GOOGLE MAP -->

          <google-map
            #map_result
            width="100%"
            height="400px"
            [center]="card.position"
            [zoom]="zoom"
            [options]="options"
            [mapTypeId]="mapType"
            (mapReady)="onMapReady($event)"
          >
            <div class="minimap">
              <div class="zoom-ctrl ctrl"></div>
              <div class="other-ctrl ctrl">
                <div #expand_web [hidden]="true" class="expand-map-type"></div>
              </div>
            </div>
            <map-marker
              #cardId="mapMarker"
              [position]="card.position"
              [icon]="icon"
            ></map-marker>
            <map-marker-clusterer
              [options]="clusterOptions"
              [imagePath]="clusterImage"
              [imageSizes]="[58, 56]"
            >
              <map-marker
                #markerId="mapMarker"
                *ngFor="let nearby of cards"
                [position]="nearby.position"
                [icon]="nearby.icon"
              ></map-marker>
            </map-marker-clusterer>

            <map-info-window>
              <div
                class="card-info-content"
                routerLink="/fiche/{{ !!card?.subcategory?.id }}/{{ card.id }}"
              >
                <div class="card-info-title-div">
                  <h3
                    class="info-title title-top upper"
                    [innerHTML]="card.title"
                  ></h3>
                  <h4 class="info-title title-bot">{{ card.city.name }}</h4>
                </div>
              </div>
            </map-info-window>
            <map-kml-layer [url]="kmlUrl"></map-kml-layer>
          </google-map>

          <!-- INFORMATIONS  -->
          <div
            id="map-box-infomations"
            *ngIf="card?.category != '4' && card?.address != ''"
          >
            <p id="info-label">INFORMATIONS</p>

            <div class="location-block" *ngIf="card.category == 1">
              <mat-icon class="location-icon" color="primary"
                >location_on</mat-icon
              >
              <p class="location-content">
                Départ : {{ card?.city.name }} - {{ card?.city.zipCode }}<br />
                Arrivée : {{ card?.endCity.name }} - {{ card?.endCity.zipCode }}
              </p>
            </div>

            <div class="location-block" *ngIf="card.category == 0">
              <mat-icon class="location-icon" color="primary"
                >location_on</mat-icon
              >
              <p class="location-content">
                {{ card?.address }}<br />{{ card?.city?.zipCode }} -
                {{ card?.city?.name }}
              </p>
            </div>

            <div
              class="location-block"
              *ngIf="card?.access != undefined && card?.access !== ''"
            >
              <mat-icon color="primary" class="location-icon">info</mat-icon>
              <p class="info-font" [innerHTML]="card?.access"></p>
            </div>

            <div class="info-last"></div>
          </div>
          <!-- END -->
        </div>
      </div>
    </div>
    <!-- END PAGE BREAK -->
  </div>
</div>
